var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 4.66699L6.77726 8.47729C7.21804 8.78583 7.43844 8.94011 7.67816 8.99986C7.88991 9.05265 8.11139 9.05265 8.32314 8.99986C8.56287 8.94011 8.78326 8.78583 9.22404 8.47729L14.6673 4.66699M4.53398 13.3337H11.4673C12.5874 13.3337 13.1475 13.3337 13.5753 13.1157C13.9516 12.9239 14.2576 12.618 14.4493 12.2416C14.6673 11.8138 14.6673 11.2538 14.6673 10.1337V5.86699C14.6673 4.74689 14.6673 4.18683 14.4493 3.75901C14.2576 3.38269 13.9516 3.07673 13.5753 2.88498C13.1475 2.66699 12.5874 2.66699 11.4673 2.66699H4.53398C3.41388 2.66699 2.85383 2.66699 2.426 2.88498C2.04968 3.07673 1.74372 3.38269 1.55197 3.75901C1.33398 4.18683 1.33398 4.74689 1.33398 5.86699V10.1337C1.33398 11.2538 1.33398 11.8138 1.55197 12.2416C1.74372 12.618 2.04968 12.9239 2.426 13.1157C2.85383 13.3337 3.41388 13.3337 4.53398 13.3337Z",
    stroke: "#667085",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail01);
export default __webpack_public_path__ + "static/media/mail-01.bcb2ce8d6e84c922dbe357c6896dc01b.svg";
export { ForwardRef as ReactComponent };